import React, { createRef } from 'react'
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from 'react-places-autocomplete'
import { withRouter } from 'react-router-dom'
import QueryString from 'query-string'
import { Button } from 'components/elements'
import globeIcon from '../assets/images/searchbar/globe-icon.webp'
import SearchOptions from './searchOptions.js'
import { trackSearchFromHeader } from '../../elements/tracking/searchTracking.js'
import './searchAutoComplete.css'
import { trackSearchLocationFromGeneralPages } from './../../elements/klaviyoTracking/generalSearch'
var classnames = require('classnames')

const searchOptions = {
  //location: new google.maps.LatLng(41.850033, -87.6500523),
  types: ['geocode'],
}

const searchIcon = (
  <img
    height="75px"
    width="75px"
    className="globe-icon"
    src={globeIcon}
    alt="globe-icon"
    data-nosnippet
  ></img>
)

function moveCursorToEnd(inputEl) {
  const len = inputEl.value.length
  if (inputEl.setSelectionRange) {
    inputEl.setSelectionRange(len, len)
  } else if (inputEl.createTextRange) {
    var t = inputEl.createTextRange()
    t.collapse(true)
    t.moveEnd('character', len)
    t.moveStart('character', len)
    t.select()
  }
}

class SearchBar extends React.Component {
  constructor(props) {
    super(props)

    const parsedQueries = QueryString.parse(this.props.location.search)

    let urlLocation = parsedQueries.location

    if (parsedQueries.location) {
      urlLocation = parsedQueries.location
    }

    this.state = {
      address:
        this.props.defaultAddress !== undefined
          ? this.props.defaultAddress
          : '',
      errorMessage: '',
      headerHeight: 150,
      searchFocused: false,
      searchIconImage: searchIcon,
      searchIconPosition: 'left',
      showSearchOptions: false,
      lastSearch: urlLocation,
      suggestions: {},
      isFocused: false,
    }
  }

  inputRef = createRef()

  componentDidMount() {
    if (this.props.focusSearch) {
      this.inputRef.current.focus()
    }
    if (this.props.grabAddressFromURL) {
      let newParsedFilters = QueryString.parse(this.props.location.search)
      if (newParsedFilters?.location?.includes('Best Motorcycle')) {
        let cityAndState =
          newParsedFilters.location
            .split('The Best Motorcycle Rentals in ')[1]
            .trim() + ', USA'
        this.setState({ address: cityAndState })
      } else {
        this.setState({ address: newParsedFilters.location })
      }
    }
  }

  componentWillUnmount() {
    document.body.classList.remove('desktop-search-focused')
    document.body.classList.remove('mobile-search-focused')
  }

  componentDidUpdate(prevProps, props) {
    if (this.props.defaultAddress !== prevProps.defaultAddress) {
      this.setState({
        address:
          this.props.defaultAddress !== undefined
            ? this.props.defaultAddress
            : '',
      })
    }

    if (this.props.isMobile !== prevProps.isMobile) {
      document.body.classList.remove('mobile-search-focused')
      document.body.classList.remove('desktop-search-focused')
      this.inputRef.current.blur()
      this.setState({
        searchFocused: false,
        searchIconImage: searchIcon,
        searchIconPosition: 'left',
        showSearchOptions: false,
      })
    }

    if (this.props.focusSearch !== prevProps.focusSearch) {
      if (this.props.focusSearch) {
        this.inputRef.current.focus()
        moveCursorToEnd(this.inputRef.current)
      }
    }
  }

  handleChange = (address) => {
    this.setState({
      address,
      errorMessage: '',
    })
  }

  handleSelect = (selected, updateLocationContainer) => {
    console.log('selected', selected);
    if (this.props.headerBar === true) {
      trackSearchLocationFromGeneralPages(selected)
    }
    document.body.classList.remove('mobile-search-focused')
    document.body.classList.remove('desktop-search-focused')
    this.inputRef.current.blur()
    this.setState({
      isGeocoding: true,
      searchFocused: false,
      address: selected,
      searchIconImage: searchIcon,
      searchIconPosition: 'left',
      showSearchOptions: false,
    })

    geocodeByAddress(selected)
      .then((res) => {
        return getLatLng(res[0]).then((latlng) => {
          return {
            ...latlng,
          }
        })
      })
      .then(
        ({
          lat,
          lng,
        }) => {
          this.setState({
            latitude: lat,
            longitude: lng,
            isGeocoding: false,
            lastSearch: selected,
          })

          if (this.props.selectSubmit) {
            trackSearchFromHeader({
              search_location: selected,
              search_latitude: lat,
              search_longitude: lng,
            })
            this.props.history.push(
                `/search?location=${selected}&latitude=${lat}&longitude=${lng}&min_distance=0&max_distance=75${this.props.makes ? 'makes=' + this.props.makes : ''}`
              )

            updateLocationContainer({
              location: selected,
              lat: lat,
              lng: lng,
            })
          } else {
            this.props.onSelect(
              selected,
              lat,
              lng,
              updateLocationContainer,
            )
          }
        }
      )
      .catch((error) => {
        this.setState({ isGeocoding: false })
      })
  }

  handleCloseClick = () => {
    this.setState({
      address: '',
      latitude: null,
      longitude: null,
    })
  }

  handleSearchFocus = () => {
    this.setState({ isFocused: true })
    if (this.props.isMobile) {
      document.body.classList.add('mobile-search-focused')
      this.setState({
        searchFocused: true,
        searchIconImage: false,
        searchIconPosition: false,
      })
    } else {
      document.body.classList.add('desktop-search-focused')
    }

    this.setState({
      showSearchOptions: true,
    })

    this.props.onFocus()
  }
  handleSearchBlur = () => {
    if (!this.props.isMobile) {
      document.body.classList.remove('desktop-search-focused')
      this.setState({
        showSearchOptions: false,
      })
    }

    this.props.onBlur()

    this.setState({ isFocused: false })
  }

  handleError = (status, clearSuggestions) => {
    this.setState({ errorMessage: status })
    clearSuggestions()
  }

  clickOff = () => {
    let address = this.state.lastSearch
    this.setState({
      showSearchOptions: false,
      address,
      searchFocused: false,
      searchIconImage: searchIcon,
      searchIconPosition: 'left',
    })
    document.body.classList.remove('mobile-search-focused')
  }

  handleRecentSearch = (searchInfo) => {
    document.body.classList.remove('mobile-search-focused')
    document.body.classList.remove('desktop-search-focused')
    this.inputRef.current.blur()
    this.setState({
      isGeocoding: true,
      searchFocused: false,
      address: searchInfo.location ? searchInfo.location : ' ',
      searchIconImage: searchIcon,
      searchIconPosition: 'left',
      showSearchOptions: false,
    })

    this.props.history.push(searchInfo.link)
  }

  render() {
    const {
      address,
      searchFocused,
      searchIconImage,
      showSearchOptions,
    } = this.state

    let searchBarInputClass = classnames(
      'search-input input',
      this.props.className,
      {
        'search-input-desktop': this.props.isMobile === false,
        'search-input-mobile': this.props.isMobile === true,
        'search-input-focused': searchFocused === true,
      }
    )

    let controlClass = classnames('control is-relative', null, {
      'has-icons-right': address,
      'has-icons-left':
        (this.props.isMobile && !address) || !this.props.isMobile,
    })

    return (
      <>
        <PlacesAutocomplete
          onChange={this.handleChange}
          // this fixes the null console warning
          value={address ? address : ''}
          onSelect={(selected) =>
            this.handleSelect(selected, this.props.searchObject.updateLocation)
          }
          onError={this.handleError}
          searchOptions={searchOptions}
        >
          {({
            getInputProps,
            suggestions,
            getSuggestionItemProps,
            loading,
          }) => {
            let searchOptionsClass = classnames(
              'search-options-dropdown',
              null,
              {
                'suggestions-found': suggestions.length > 0,
              }
            )
            return (
              <div className="search-header-wrapper">
                <div className="field mb-0 header-search-input-wrap">
                  <div className={controlClass}>
                    <input
                      {...getInputProps({
                        placeholder: this.props.searchPlaceHolder,
                        className: loading
                          ? searchBarInputClass + ' is-loading'
                          : searchBarInputClass,
                      })}
                      ref={this.inputRef}
                      onFocus={() => this.handleSearchFocus()}
                      onBlur={() => this.handleSearchBlur()}
                    />
                    {this.props.isMobile && !this.state.address && (
                      <div>
                        <span className="icon is-small is-left">
                          {this.props.overRideIcon
                            ? this.props.overRideIcon
                            : this.props.isHeaderSearchbar
                            ? null
                            : searchIconImage}
                        </span>
                      </div>
                    )}
                    {!this.props.isMobile && (
                      <span className="icon is-small is-left">
                        {this.props.overRideIcon
                          ? this.props.overRideIcon
                          : searchIconImage}
                      </span>
                    )}

                    {this.state.address && this.props.isHeaderSearchbar && (
                      <button
                        className="icon is-small is-right header-search-icon"
                        style={{
                          pointerEvents: 'initial',
                          textDecoration: 'none',
                          background:
                            'linear-gradient(180deg, #FFEC3B 0%, #E2BC00 100%)',
                          borderRadius: '20px',
                          border: 'none',
                          color: '#000000',
                          marginTop: '5px',
                          marginRight: '7px',
                          cursor: 'pointer',
                        }}
                        onClick={() => {
                          this.setState({ address: '' })
                          this.inputRef.current.focus()
                        }}
                      >
                        <i
                          className="fal fa-search"
                          style={{ fontWeight: '600' }}
                        ></i>
                      </button>
                    )}
                    {!this.props.isMobile && this.props.isHeaderSearchbar && (
                      <button
                        className="icon is-small is-right header-search-icon"
                        style={{
                          pointerEvents: 'initial',
                          textDecoration: 'none',
                          background:
                            'linear-gradient(180deg, #FFEC3B 0%, #E2BC00 100%)',
                          borderRadius: '20px',
                          border: 'none',
                          color: '#000000',
                          marginTop: '5px',
                          marginRight: '7px',
                          cursor: 'pointer',
                        }}
                        onClick={() => {
                          this.setState({ address: '' })
                          this.inputRef.current.focus()
                        }}
                      >
                        <i
                          className="fal fa-search"
                          style={{ fontWeight: '600' }}
                        ></i>
                      </button>
                    )}
                  </div>
                </div>

                {suggestions.length > 0 && (
                  <div className={searchOptionsClass}>
                    {suggestions.length > 0 && showSearchOptions && (
                      <SearchOptions
                        suggestions={suggestions}
                        isMobile={this.props.isMobile}
                        getSuggestionItemProps={getSuggestionItemProps}
                      />
                    )}
                  </div>
                )}
                {this.props.isMobile && (
                  <Button
                    className="search-header-cancel-button"
                    onClick={() => this.clickOff(suggestions)}
                  >
                    Cancel
                  </Button>
                )}
              </div>
            )
          }}
        </PlacesAutocomplete>
      </>
    )
  }
}

export default withRouter(SearchBar)

SearchBar.defaultProps = {
  grabAddressFromURL: true,
  selectSubmit: true,
  onSelect: function() {},
  searchPlaceHolder: 'Search Places...',
  focusSearch: false,
  onBlur: function() {},
  onFocus: function() {},
  searchObject: null,
  defaultAddress: null,

  //Style Related:
  inputClassName: null,
  overRideIcon: false,
  size: 'big',
}
